export default {
  cancel: 'ยกเลิก',
  circle_config: 'การกำหนดวงกลม',
  confirm: 'ยืนยัน',
  confirm_delete: 'คุณแน่ใจหรือไม่ว่าต้องการลบฟีเจอร์นี้? การดำเนินการนี้ไม่สามารถย้อนกลับได้。',
  create: 'สร้าง',
  delete_geometry: 'ลบเรขาคณิต',
  delete_vertex: 'ลบจุดยอด',
  document_upload_failed: 'การอัปโหลดเอกสารล้มเหลว',
  draw_circle: 'วงกลมจากศูนย์กลาง',
  draw_circle_2pt: 'วงกลมด้วยมือ',
  draw_dialog_begin_drawing: 'เริ่มวาด - คลิกที่ใดก็ได้บนแผนที่',
  draw_dialog_cancel_drawing: 'ยกเลิกการวาด - กด ESC',
  draw_dialog_remove_vertex: 'ลบจุดยอดสุดท้าย - คลิกขวา',
  draw_dialog_save: 'บันทึก - คลิกสองครั้ง',
  draw_dialog_save_single: 'บันทึก - คลิกครั้งเดียว',
  draw_dialog_title: 'คำแนะนำการวาด',
  draw_line: 'เส้น',
  draw_point: 'จุด',
  draw_polygon: 'รูปหลายเหลี่ยม',
  draw_position: 'ตำแหน่งปัจจุบัน',
  draw_rectangle: 'รูปสี่เหลี่ยม',
  edit_dialog_cancel_drawing: 'ยกเลิกการวาด - คลิกที่ปุ่มยกเลิกเพื่อยกเลิกการวาด',
  edit_dialog_modify_shape:
    'แก้ไขรูปทรง - ลากจุดยอดเพื่อตกแต่งรูปทรง หรือเพิ่มจุดยอดใหม่บนรูปหลายเหลี่ยม',
  edit_dialog_remove_vertex: 'ลบจุดยอด - คลิกที่จุดยอดเพื่อลบ',
  edit_dialog_save: 'บันทึก - คลิกที่ปุ่มบันทึกเพื่อบันทึกการเปลี่ยนแปลงของคุณ',
  edit_dialog_title: 'คำแนะนำการแก้ไข',
  filter_searchbox_placeholder: 'ค้นหา',
  icon_scaling_cluster: 'ขนาดไอคอนกลุ่ม',
  icon_scaling_cluster_log: 'ขนาดโลจิสติกของกลุ่ม',
  icon_scaling_field: 'เปลี่ยนขนาดไอคอนฟิลด์',
  icon_scaling_label: 'ขนาดไอคอน',
  icon_scaling_zoom_in: 'ขนาดซูมเข้า',
  icon_scaling_zoom_out: 'ขนาดซูมออก',
  identical_values_filter: 'ฟิลด์นี้มีค่าเดียวที่แตกต่างกันและไม่สามารถกรองได้',
  image_upload_failed: 'การอัปโหลดภาพล้มเหลว',
  information: 'ข้อมูล',
  invalid_geometry: 'เรขาคณิตไม่ถูกต้อง',
  invalid_lat_lon: 'พิกัดที่ให้มาไม่ได้อยู่ในเขตที่เลือก',
  invalid_lat_long_range: 'พิกัดไม่ถูกต้อง: ค่าละติจูดและลองจิจูดต้องอยู่ในช่วงที่ถูกต้อง',
  layer_add_new_location: 'เพิ่มตำแหน่งใหม่',
  layer_dataview_header: 'มุมมองข้อมูล',
  layer_filter_clear_all: 'ลบตัวกรองทั้งหมด',
  layer_filter_dropdown_select: 'เลือกหลายรายการ',
  layer_filter_greater_than: 'มากกว่า',
  layer_filter_header: 'ตัวกรอง',
  layer_filter_less_than: 'น้อยกว่า',
  layer_filter_reset_all: 'รีเซ็ตตัวกรองทั้งหมด',
  layer_filter_select: 'เลือกตัวกรองจากรายการ',
  layer_filter_set_filter: 'ตั้งค่าตัวกรอง',
  layer_grid_legend_ratio: 'แสดงสีเป็นอัตราส่วนกับขนาด',
  layer_group_hide_layers: 'ซ่อนทุกชั้นในกลุ่ม',
  layer_style_cluster: 'หลายตำแหน่ง',
  layer_style_display_hover: 'เปิดใช้งานการเลื่อนเมาส์',
  layer_style_display_labels: 'แสดงป้าย',
  layer_style_header: 'สไตล์',
  layer_style_opacity: 'เปลี่ยนความทึบของชั้น:',
  layer_style_select_theme: 'เลือกสไตล์ธีม',
  layer_style_switch_all: 'เปลี่ยนทั้งหมด',
  layer_style_switch_caption: 'คลิกที่ป้ายเพื่อตั้งค่าความสามารถในการมองเห็นหรือ',
  layer_visibility: 'เปลี่ยนความสามารถในการมองเห็น',
  layer_zoom_to_extent: 'ซูมไปที่ขอบเขตของชั้นที่กรอง',
  layers: 'ชั้น',
  link: 'ลิงก์',
  loading: 'กำลังโหลด',
  location_clear_all: 'ล้างตำแหน่งทั้งหมด',
  location_close_without_save: 'ปิดตำแหน่งโดยไม่บันทึกการเปลี่ยนแปลง?',
  location_delete: 'ลบตำแหน่ง',
  location_listview_full: 'มุมมองรายการสำหรับตำแหน่งเต็ม',
  location_remove: 'ลบฟีเจอร์ออกจากการเลือก',
  location_save: 'บันทึกการเปลี่ยนแปลงไปยังคลาวด์',
  location_save_changes: 'คุณต้องการบันทึกการเปลี่ยนแปลงในตำแหน่งนี้หรือไม่?',
  location_zoom: 'ซูมแผนที่ไปที่ขอบเขตฟีเจอร์',
  locations: 'ตำแหน่ง',
  modify_geometry: 'ปรับเปลี่ยนเรขาคณิต',
  no_data_filter: 'ฟิลด์นี้ไม่มีข้อมูลและไม่สามารถกรองได้',
  no_layers: 'ไม่มีชั้นที่สามารถเข้าถึงได้ในพื้นที่',
  no_locales:
    'บัญชีของคุณได้รับการตรวจสอบและอนุมัติแล้ว แต่คุณไม่มีสิทธิ์เข้าถึงพื้นที่ใด ๆ ซึ่งอาจเป็นเพราะผู้ดูแลระบบไม่ได้ให้บทบาทที่จำเป็นกับคุณ กรุณาติดต่อผู้ดูแลระบบเพื่อแก้ไขปัญหานี้',
  no_options_available: 'ไม่มีตัวเลือกที่มีให้',
  no_results: 'ไม่พบผลลัพธ์สำหรับการค้นหานี้',
  ok: 'ตกลง',
  pill_component_remove: 'ลบ',
  pin: 'ปักหมุด',
  radius: 'รัศมี',
  remove_document_confirm:
    'คุณแน่ใจหรือว่าต้องการลบเอกสารนี้? การดำเนินการนี้ไม่สามารถย้อนกลับได้',
  remove_image_confirm: 'คุณแน่ใจหรือว่าต้องการลบภาพ? การดำเนินการนี้ไม่สามารถย้อนกลับได้',
  remove_item_confirm: 'ลบรายการ?',
  remove_last_vertex: 'ลบจุดยอดสุดท้าย',
  report: 'รายงาน',
  save: 'บันทึก',
  toolbar_admin: 'เปิดมุมมองผู้ดูแลบัญชี',
  toolbar_current_location: 'ตำแหน่งปัจจุบัน',
  toolbar_fullscreen: 'มุมมองแผนที่แบบเต็มหน้าจอ',
  toolbar_login: 'เข้าสู่ระบบ',
  toolbar_logout: 'ออกจากระบบ',
  toolbar_zoom_in: 'ซูมเข้า',
  toolbar_zoom_out: 'ซูมออก',
  toolbar_zoom_to_area: 'ซูมไปที่พื้นที่',
  units: 'หน่วย',
  zoom_to: 'ซูมไปที่',
};
